import { useEffect, useId, useRef } from "react";
import { isDefined } from "ts-extras";
import type { Except } from "type-fest";

export const Checkbox: React.FC<
  {
    children: React.ReactNode;
    indeterminate?: boolean;
  } & Except<React.ComponentProps<"input">, "type">
> = ({ children, indeterminate, ...props }) => {
  const id = useId();
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current && isDefined(indeterminate)) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <div className="flex gap-2 py-2">
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="checkbox"
        {...props}
      />
      <label htmlFor={id} className="label-text flex items-center gap-1">
        {children}
      </label>
    </div>
  );
};
